import React from "react";

const Departament = ({ title, subtitle, items }) => (
    <div className="departments-item">
      <div className="departments-item__inner">
        <p className="departments-item__title">
          <font><font>{title}</font></font>
        </p>
        <p>
          <font><font>{subtitle}</font></font>
        </p>
        {items.map(({href, text, subInfo, subHeader}) => (
            <p>
                {subHeader && <p>{subHeader}</p>}
                <br/>
                {text && <a href={href} className="big">
                    <font><font>{text}</font></font><br />
                </a>}
                {subInfo && <p>
                    <font><font>{subInfo}</font></font>
                </p>}
            </p>
        ))}
      </div>
    </div>
)

export default Departament;